import axiosInstance from '../axiosInterceptor/axiosInstance'

const updateOrgUser = async (data) => {
  const { orgId, requestBody } = data
  // The user changed is the route's; the body still names it, as the backend accepts.
  const url = `v1/orgs/${orgId}/users/${requestBody.userId}`
  return axiosInstance.patch(url, requestBody)
}

export default updateOrgUser
